import {Component, OnInit} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {isEmpty, routePath} from 'sdv-common';
import {ApiService} from '../service/api.service';
import {getBrowserName, getDevice, getIp, getOs, keys, redirect, reload} from '../shared/constants';
import {UserService} from '../service/user.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  readonly isEmpty = isEmpty;

  auth = {
    otp: '',
    contact: '',
    password: ''
  };
  message = '';
  isReset = false;
  error = '';
  loading = false;
  submitted = false;

  constructor(public apiService: ApiService,
              public userService: UserService,
              public cookieService: CookieService) {
    if (this.apiService.isAuthorized()) {
      redirect(routePath.root);
    }
    this.message = this.apiService.getParam('message');
    this.apiService.setParams({message: null});
  }

  ngOnInit() {
  }

  changeType(type: string = undefined) {
    this.error = '';
    this.submitted = false;
    this.apiService.setParams({'type': type});
  }

  sign() {
    this.error = '';
    this.submitted = true;
    let type = this.apiService.getParam('type') || '';
    if (isEmpty(type)) {
      type = 'password';
    }
    if (isEmpty(this.auth.contact)) {
      return;
    }
    if (type === 'password' && isEmpty(this.auth.password)) {
      return;
    }
    if (type === 'otp' && isEmpty(this.auth.otp)) {
      return;
    }
    this.loading = true;

    let _this = this;
    if (type === 'password') {
      this.userService.auth(this.auth)
        .catch((err) => {
          _this.loading = false;
        });
    } else if (type === 'reset') {
      this.apiService.post('users/reset',
        {
          contact: this.auth.contact
        })
        .subscribe(res => {
          _this.changeType('otp');
          _this.isReset = true;
          _this.loading = false;
        }, err => {
          _this.error = err.error.message;
          _this.loading = false;
        });
    } else if (type === 'otp') {
      this.apiService.post('users/auth',
        {
          contact: this.auth.contact,
          browser: getBrowserName(),
          otp: this.auth.otp,
          device: getDevice(),
          ip: getIp(),
          os: getOs()
        })
        .subscribe(res => {
          const expires = new Date();
          expires.setDate(expires.getDate() + 30);
          _this.cookieService.set(keys.sid, res.value, expires);
          if (_this.isReset) {
            reload(routePath.profile);
          } else {
            reload(routePath.home);
          }
        }, err => {
          _this.error = err.error.message;
          _this.loading = false;
        });
    } else {
      debugger;
    }
  }
}
